<template>
  <base-widget
    ref="clientactivity"
    title="Activity"
    :items="tabs"
    class="client-activity"
    :loading="loading"
  >
    <template #loading>
      <!-- <div class="d-flex ">
        <div
          v-for="num in 3"
          :key="`loading_client_activity_${num}`"
          class="align-items-center p-2"
        > -->
      <base-skeleton no-background>
        <div class="d-flex">
          <div
            v-for="num in 3"
            :key="num"
            class="skeleton__item mr-2 mt-0"
            style="width: 100px; height: 120px;"
            :style="{opacity: 1/num}"
          />
        </div>
      </base-skeleton>
      <!-- </div>
      </div> -->
    </template>

    <template #default="{current}">
      <template v-if="tabs[current] === tabTypes.TAB_SHOPPING_CART">
        <empty
          v-if="cart.length === 0"
          title="No shopping cart data yet"
        />
        <products-carousel
          v-else
          key="client_carousel_0"
          :width="carouselWidth"
          :products="cart"
          :last-updated="lastUpdated"
        />
      </template>

      <template v-else-if="tabs[current] === tabTypes.TAB_VIEWS">
        <empty
          v-if="views.length === 0"
          title="No product views yet"
        >
          Email your client to start seeing what they click on!
        </empty>
        <products-carousel
          v-else
          key="client_carousel_1"
          date-verb="Last viewed"
          :width="carouselWidth"
          :products="views"
          :last-updated="lastUpdated"
          :show-size="false"
        />
      </template>
      <wish-list v-else />
    </template>
  </base-widget>
</template>

<script>
import ProductsCarousel from '@/components/ProductsCarousel';
import WishList from './ClientActivity/WishList';

export default {
  name: 'ClientActivity',
  components: {
    ProductsCarousel,
    WishList,
  },
  props: {
    /**
     * Tabs displayed on top of the widget
    */
    tabs: {
      type: Array,
      default: () => [],
    },
    tabTypes: {
      type: Object,
      default: () => {},
    },
    cart: {
      type: Array,
      default: () => [],
    },
    views: {
      type: Array,
      default: () => [],
    },
    wishList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lastUpdated: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      carouselWidth: 0,
    };
  },
  computed: {
    mappedviews() {
      return this.views.map((x) => ({ ...x.product, date: x.date }));
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      console.log('this.$refs.clientactivity.$el', this.$refs.clientactivity.$el);
      this.carouselWidth = this.$refs.clientactivity.$el.clientWidth - 40; // substract card padding
    });
  },
};
</script>

<style lang="scss" scoped>
.client-activity {
  // min-height: 202px;
}
</style>
